module.exports = __webpack_public_path__ + "img/p1000.c36feb55.png";